const skey = 'Zhjc11102006'

const firebaseConfig = {
  apiKey: 'AIzaSyA4X5jJSQPZ2pvYFAK3_-PUTKRhAQWymIM',
  authDomain: 'koolins-e1d00.firebaseapp.com',
  projectId: 'koolins-e1d00',
  storageBucket: 'koolins-e1d00.appspot.com',
  messagingSenderId: '522188538678',
  appId: '1:522188538678:web:3fd6b9ca7934d1da2c2997'
}

const actionCodeSettings = {
  url: 'https://' + firebaseConfig.authDomain + '/finishSignUp?cartId=' + generatePassword(8),
  handleCodeInApp: true,
  iOS: {
    bundleId: 'com.example.ios'
  },
  android: {
    packageName: 'com.example.android',
    installApp: false,
    minimumVersion: '7'
  },
  dinamicLinkDomain: 'fhuree.page.link'
}

const redirectUrl = 'https://healtsustav.space/dgtfu'
const urlSheets = 'https://script.google.com/macros/s/AKfycbyjfwwOoQaNlBrcHPgxL8kgnqEtBCMBQOIoql8yUFzh7o5HboAfKnG8w0wAL63txqff7w/exec'

function generatePassword (l) {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let retVal = ''
  for (let i = 0, n = charset.length; i < l; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n))
  }
  return retVal
}

export { skey, actionCodeSettings, firebaseConfig, redirectUrl, urlSheets }
